(function () {
  'use strict';

  function initHeroSlider(root) {
    var track = root.querySelector('[data-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));

    if (slides.length <= 1) return;

    var current = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var timer = null;

    function playVideosOn(index) {
      slides.forEach(function (slide, i) {
        var videos = slide.querySelectorAll('video');
        videos.forEach(function (v) {
          if (i === index) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      });
    }

    function goTo(index) {
      var newIndex = (index + slides.length) % slides.length;

      slides[current].classList.remove('is-active');
      slides[current].classList.remove('is-prev');
      if (newIndex < current) {
        slides[current].classList.add('is-prev');
      }

      slides[newIndex].classList.add('is-active');
      slides[newIndex].classList.remove('is-prev');

      if (dots.length) {
        dots[current] && dots[current].classList.remove('is-active');
        dots[newIndex] && dots[newIndex].classList.add('is-active');
      }

      current = newIndex;
      playVideosOn(current);
      resetAutoplay();
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function resetAutoplay() {
      if (autoplay) startAutoplay();
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    // Pause autoplay on hover / focus, resume on leave
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', resetAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', resetAutoplay);

    // Touch swipe support
    var touchStartX = 0;
    var touchEndX = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          next();
        } else {
          prev();
        }
      }
    }, { passive: true });

    // Pause offscreen slider (e.g. scrolled away) to save resources
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            resetAutoplay();
            playVideosOn(current);
          } else {
            stopAutoplay();
          }
        });
      }, { threshold: 0.15 });
      observer.observe(root);
    } else {
      startAutoplay();
    }

    playVideosOn(current);
  }

  function initAll() {
    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when section is added/edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var slider = e.target.querySelector('[data-hero-slider]');
    if (slider) initHeroSlider(slider);
  });
})();